import { LocaleEnum } from '@systemeio/ui-frontend'

export const getCalculatedLanguage = (language: string) => {
  let readableLanguage
  switch (language) {
    case LocaleEnum.JAPANESE:
      readableLanguage = 'jp'
      break
    default:
      readableLanguage = language
  }

  return readableLanguage.toUpperCase()
}
